module.exports = __webpack_public_path__ + "img/afther-2.2d44e369.png";